import axiosInstance from "../lib/axios";

interface GetProductsRequest {
  page?: number;
  limit?: number;
  search?: string;
}

export const getProducts = async ({
  page = 1,
  limit = 10,
  search
}: GetProductsRequest) => {
  const body = {
    page,
    limit,
    search
  };

  const { data } = await axiosInstance.post("/Product/List", body);

  return data;
};

export const createProduct = (data: FormData) => {
  return axiosInstance.post("/Product/Create", data);
};

export const updateProduct = (id: number, data: FormData) => {
  return axiosInstance.put(`/Product/${id}`, data);
};

export const getProductById = (id: number) => {
  return axiosInstance.get(`/Product/${id}`);
};

export const deleteProductById = (id: number) => {
  return axiosInstance.delete(`/Product/${id}`);
};